/* eslint-disable react/no-unused-state */
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withFormik, Form, Field } from "formik";
import { bool, string, func } from "prop-types";
import * as Yup from "yup";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { selectors as loginSelectors, actions as loginActions } from "reducers/login";
import * as i18n from "util/i18n";
import Credential from "pages/_components/fields/credentials/Credential";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import { Mixpanel } from "util/clickstreaming";
import { push } from "connected-react-router";

const FORM_ID = "login.step1";

class UserForm extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        isFetching: bool.isRequired,
        className: string,
        dispatch: func.isRequired,
        isVerifyUserCredentialsForm: bool,
        onboardingWithInvitation: bool.isRequired,
    };

    static defaultProps = {
        className: "",
        isVerifyUserCredentialsForm: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            showCuilForm: true,
        };
    }

    componentDidMount() {
        const { isVerifyUserCredentialsForm, onboardingWithInvitation } = this.props;

        this.setState({
            showCuilForm: !isVerifyUserCredentialsForm || !onboardingWithInvitation,
        });
    }

    handleClickModalForgotUser = () => {
        const { dispatch } = this.props;
        dispatch(push("/recovery/username/step1"));
    };

    render() {
        const { isDesktop, isFetching, className, isVerifyUserCredentialsForm } = this.props;
        const { showCuilForm } = this.state;
        return (
            <Form className={className} noValidate="novalidate">
                {showCuilForm && (
                    <Field
                        idForm={FORM_ID}
                        name="username"
                        component={TextField}
                        labelText="administration.channels.cuil"
                        autoFocus={isDesktop}
                        onlyNumbers
                    />
                )}
                <Field
                    idForm={FORM_ID}
                    name="usernameSecret"
                    component={Credential}
                    labelText="administration.channels.usernameSecret"
                    autoFocus={isDesktop}
                />
                <Button
                    type="submit"
                    bsStyle="primary"
                    label="global.continue"
                    loading={isFetching}
                    block
                    className="mt-4"
                />
                {!isVerifyUserCredentialsForm && (
                    <Button bsStyle="link" onClick={this.handleClickModalForgotUser} label="onboarding.forgotUser" />
                )}
            </Form>
        );
    }
}

const mapStateToProps = (state) => ({
    isFetching: loginSelectors.getFetching(state),
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: () => ({
            username: "",
            usernameSecret: "",
        }),
        validationSchema: (props) => {
            const { isVerifyUserCredentialsForm, onboardingWithInvitation } = props;
            return Yup.object().shape({
                username:
                    !isVerifyUserCredentialsForm || !onboardingWithInvitation
                        ? Yup.number().required(i18n.get("onboarding.step4.username.error.empty"))
                        : Yup.number().notRequired(),
                usernameSecret: Yup.string().required(i18n.get("recoveryPassword.step1.username.required")),
            });
        },
        handleSubmit: ({ username, rememberEmail, usernameSecret }, formikBag) => {
            Mixpanel.identify(username);
            Mixpanel.track(FORM_ID, { rememberEmail });
            const { props } = formikBag;
            const { isVerifyUserCredentialsForm } = props;
            if (isVerifyUserCredentialsForm) {
                props.dispatch(onboardingActions.verifyUserCredentialsStep1Migration(username, usernameSecret));
            } else {
                props.dispatch(loginActions.loginStep1(username, rememberEmail, usernameSecret, formikBag));
            }
        },
    }),
)(UserForm);
